import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton, ModalSecondaryButton } from '../..';
import "./styles.css";
import { ModalClose, useBCMSModal, useRoute } from "@bcm-dev/bcms-vite";

/**
 * @function CancelUpdateMerchantModal
 * @return {React.Component}
 * @exported true
 * @description The Cancel Update Merchant modal 
 */

export default function CancelUpdateMerchantModal(props){
  const navigate = useRoute();
  const { close } = useBCMSModal();

  const onConfirmClick = evt => {
    close("CancelUpdateMerchantModal");

    if(props.data) {
      if(props.data.onConfirmClick) {
        props.data.onConfirmClick();
      } else {
        navigate("/home/merchantdetails");
      }
    }
  }

  return(
    <CustomModal className="cancel-update-merchant-modal" id="CancelUpdateMerchantModal">
      <CustomModalContent>
          <p className="text-center">You are about to cancel the card on file update for the merchant. Please confirm.</p>
      </CustomModalContent>
      <CustomModalFooter className="button-container">
          <ModalPrimaryButton text="Confirm" onClick={ onConfirmClick }  />
          <ModalClose id="CancelUpdateMerchantModal">
            <ModalSecondaryButton text="Cancel" />
          </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  );
}